import { atom } from 'recoil';

const sessionState = atom({
  key: 'sessionState',
  default: null,
});

export { sessionState };
